import axios from '../config/axios';
import Auth from '../models/Auth';

class AuthHttpService {
    static async sendEmailCode(email) {
        try {
            const response = await axios.post(
                `${process.env.REACT_APP_API_BASE_URL}/user/send-email-code`,
                { email },
                {
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                    }
                }
            );
            return response.data;
        } catch (error) {
            throw error.response?.data || error;
        }
    }

    static async login(email, code) {
        try {
            const response = await axios.post(
                `${process.env.REACT_APP_API_BASE_URL}/login`,
                { email, code },
                {
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                    }
                }
            );
            
            const { token, admin, user } = response.data;
            return new Auth(admin.name, admin.email, token, user, admin.is_admin);
        } catch (error) {
            throw error.response?.data || error;
        }
    }

    static async checkLoggedUser(token) {
        try {
            const response = await axios.get(
                `${process.env.REACT_APP_API_BASE_URL}/auth/logged-user`,
                {
                    headers: {
                        'Accept': 'application/json',
                        'Authorization': `Bearer ${token}`
                    }
                }
            );
            return response.data;
        } catch (error) {
            throw error.response?.data || error;
        }
    }

    static async sendPasswordResetEmail(email) {
        try {
            const response = await axios.post(
                `${process.env.REACT_APP_API_BASE_URL}/password/reset-request`,
                { email },
                {
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                    }
                }
            );
            return response.data;
        } catch (error) {
            throw error.response?.data || error;
        }
    }

}

export default AuthHttpService;
